@if(asset) {
  <div class="viewerAudioWrapper">
    <nav class="mx-0 py-1 viewerRelatedAudioNavigation">
      <div class="previous-audio-button">
        @if(hasMultiple && hasPrevious) {
            <span class="sr-only">Previous audio auto button</span>
            <zbp-button-component id="viewerAudioPreviousButton"
                                  type="button"
                                  [ariaLabel]="'Previous Audio'"
                                  (clickHandler)="previous()"
                                  [attr.aria-label]="prevAudioLabel"
                                  [theme]="'blackText'"
                                  [iconSize]="'font-size'"
                                  [iconPosition]="'left'"
                                  [tooltip]="'Previous Audio'"
                                  [iconName]="zbpIconNames.audioPreviousIcon">
            </zbp-button-component>
        }
      </div>
      <div class="audio-label-text">
        <span>Audio</span>
      </div>
      <div class="next-audio-button">
        @if(hasMultiple && hasNext) {
            <span class="sr-only">Next audio auto button</span>
            <zbp-button-component id="viewerAudioNextButton"
                                  type="button"
                                  [ariaLabel]="'Next Audio'"
                                  (clickHandler)="next()"
                                  [attr.aria-label]="nextAudioLabel"
                                  [theme]="'blackText'"
                                  [iconSize]="'font-size'"
                                  [iconPosition]="'right'"
                                  [tooltip]="'Next Audio'"
                                  [iconName]="zbpIconNames.audioNextIcon">
            </zbp-button-component>
        }
      </div>
    </nav>
    <zbp-audio-player [assetName]="assetName" [audioFile]="audioFile" />
  </div>

  <!-- Separate transcript tile (always shown if transcript exists; expands in place when clicked) -->
  @if(transcript) {
    <div 
      id="transcript-tile" 
      class="transcript-tile" 
      role="region" 
      [attr.aria-expanded]="showTranscript"
      [attr.aria-label]="'Audio transcript ' + (showTranscript ? '(expanded)' : '(collapsed)')">
      <button 
        id="transcript-trigger"
        class="transcript-trigger" 
        (click)="toggleTranscript()"
        type="button"
        [attr.aria-expanded]="showTranscript"
        aria-label="transcript"
        aria-controls="transcript-content">
        <img id="transcript-icon" alt="Transcript Icon" src="../../../assets/img/transcriptIcon.svg" />
        <span class="transcript-trigger-text">Transcript</span>
      </button>
      
      <!-- Expanded content (inside the same tile, shown below button when expanded) -->
      @if(showTranscript) {
        <div 
          id="transcript-content" 
          class="transcript-content-area">
          <section class="transcript-section">
            <div class="transcript-text" [innerHTML]="transcript"></div>
          </section>
        </div>
      }
    </div>
  }
}